import React from "react"
import Layout from "@components/Layout/hoc/withDatoData"
import Helmet from "@components/Helmet"
import DatoContent from "@dato/DatoContent"
import { renderMetaTags } from "react-datocms"

const BecomeDealerPage: React.FC<{ data: any }> = ({ data }) => {
  const content = data?.page?.content || []
  const textHero = content.find(
    (c: any) => c.__typename === "ComponentTextHeroRecord"
  )
  const formSnippet = content.find(
    (c: any) => c.__typename === "ComponentCodeSnippetRecord"
  )
  const imageBlock = content.find(
    (c: any) => c.__typename === "ComponentImageRecord"
  )

  const desktopSrc = imageBlock?.image?.responsiveImage?.src
  const mobileSrc = imageBlock?.mobileImage?.responsiveImage?.src

  const buildImageUrl = (src?: string, width = 1920) =>
    src
      ? `${src}${src.includes("?") ? "&" : "?"}w=${width}&auto=format&q=90`
      : undefined

  const desktopImageUrl = buildImageUrl(desktopSrc, 1920)
  const mobileImageUrl = buildImageUrl(mobileSrc, 800)

  return (
    <Layout module="automotive">
      <Helmet
        title={data?.page?.title || "TMI Products"}
        meta={renderMetaTags(data?.page?._seoMetaTags)}
        module="automotive"
      />
      <style>{`
        .dealer-form-wrapper div {
          width: 100% !important;
          max-width: 100% !important;
          padding-left: 0 !important;
          padding-right: 0 !important;
        }
        .dealer-form-wrapper iframe {
          width: 100% !important;
          max-width: 100% !important;
          display: block;
          border: 0;
          margin: 0 auto;
        }
      `}</style>
      <div className="lg:h-screen lg:overflow-hidden">
        <div className="min-h-screen lg:h-full grid grid-cols-1 lg:grid-cols-2 w-full">
          <div className="relative lg:h-full overflow-hidden bg-gray-900">
            {(mobileImageUrl || desktopImageUrl) && (
              <img
                src={mobileImageUrl || desktopImageUrl}
                alt=""
                className="w-full h-auto object-cover lg:hidden"
              />
            )}
            {desktopImageUrl && (
              <div
                className="hidden lg:block absolute inset-0"
                style={{
                  backgroundImage: `url(${desktopImageUrl})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                }}
              />
            )}
          </div>
          <div className="flex flex-col bg-white lg:overflow-y-auto lg:h-full overflow-x-hidden">
            <div className="flex-1 flex flex-col justify-start items-center px-4 py-8 sm:px-6 sm:py-12 lg:px-12 lg:py-24 max-w-full">
              {textHero && (
                <div className="mb-4 sm:mb-6">
                  <h1 className="text-xl sm:text-2xl lg:text-4xl font-bold text-gray-900 text-center">
                    {textHero.text}
                  </h1>
                </div>
              )}
              {formSnippet && (
                <div className="dealer-form-wrapper w-full overflow-x-hidden">
                  <DatoContent content={[formSnippet]} />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default BecomeDealerPage
